import { Component, OnInit, Input } from '@angular/core';
import { OrderingService } from '../../../../../services';

@Component({
  selector: '[order-item]',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.css']
})
export class OrderItemComponent implements OnInit {
  @Input()product;
  @Input()order;

  constructor(
    public orderingService: OrderingService
  ) { }

  ngOnInit() { }
}
